/* ------------------------------------------------------------------
// NOTE: esbuild移行の一環として、基本的に過去の仕様をそのままコピペしている
// ABテスト用：応募ページの改良
--------------------------------------------------------------------- */
function toggleArticleDetailVisibility() {
  $("#jsshowMore").click(function () {
    $(this).toggleClass("isOpen");
    $("#jsArticleDetailInfo").toggleClass("isOpen");
    // NOTE: トグルが div のままのページを壊さないよう、aria-expanded を持つ場合だけ同期する
    if (this.hasAttribute("aria-expanded")) {
      this.setAttribute("aria-expanded", $(this).hasClass("isOpen"));
    }
    truncateTextWithReadMore();
    expandTruncatedText();
  });
}

function truncateTextWithReadMore() {
  $(".js4LinesLimit").trunk8({
    lines: 4,
    fill: ' &hellip;<a class="jsReadMore readMore" href="#">全て表示</a>',
    parseHTML: true,
  });
}

function expandTruncatedText() {
  $(".jsReadMore").click(function () {
    $(this).closest(".js4LinesLimit").trunk8({
      lines: 1000,
    });
    return false;
  });
}

// NOTE: esbuild はモジュールレベルの副作用がない純粋な関数宣言をバンドルから除外する
// Sprockets からの移行のため、グローバルアクセスを維持するために window に公開する

export {
  toggleArticleDetailVisibility,
  truncateTextWithReadMore,
  expandTruncatedText,
};
